import React from "react";

export const EmptyState = () => (
  <div className="flex flex-col items-center justify-center py-12">
    <p className="text-gray-500 dark:text-gray-400">No invoices available</p>
  </div>
);
